"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveControls = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var Text_1 = require("office-ui-fabric-react/lib/Text");
var LiveEditingStatus_1 = require("./LiveEditingStatus/LiveEditingStatus");
/**
 * SaveControls - Renders the unsaved-changes block: Save / Discard buttons,
 * the live-editing presence indicator, and an inline success message.
 */
exports.SaveControls = function (_a) {
    var hasUnsavedChanges = _a.hasUnsavedChanges, isSaving = _a.isSaving, successMessage = _a.successMessage, liveEditors = _a.liveEditors, onSave = _a.onSave, onDiscard = _a.onDiscard, onDismissSuccess = _a.onDismissSuccess;
    return (react_1.default.createElement("div", { className: "ws-save-controls" },
        react_1.default.createElement(Text_1.Text, { variant: "small", className: "ws-save-controls-label" }, "Unsaved Changes"),
        react_1.default.createElement("div", { className: "ws-save-controls-row" },
            react_1.default.createElement(Button_1.PrimaryButton, { text: "Save Changes", iconProps: {
                    iconName: isSaving ? "Sync" : "Save",
                    className: isSaving ? "ws-spin" : "",
                }, title: "Save all changes", ariaLabel: "Save all changes", onClick: onSave, disabled: !hasUnsavedChanges || isSaving, className: "ws-admin-button-filled-primary ws-save-changes-btn" }),
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: "Undo" }, title: "Discard Changes", ariaLabel: "Discard Changes", className: "ws-admin-button-neutral-icon ws-discard-changes-btn", onClick: onDiscard, disabled: !hasUnsavedChanges || isSaving }),
            react_1.default.createElement("div", { "aria-hidden": "true", className: "ws-live-editing-separator" }),
            react_1.default.createElement(LiveEditingStatus_1.LiveEditingStatus, { editors: liveEditors })),
        successMessage && (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.success, onDismiss: onDismissSuccess, dismissButtonAriaLabel: "Close", styles: { root: { marginTop: 6 } } }, successMessage))));
};
